/**
 * A project as `GET /projects` sends it. Snake case, because it is the row.
 *
 * The fee is optional in the type for the same reason it is optional in the
 * answer: the server takes it out for anybody who is not a partner, so a
 * screen that reads it has to cope with it not being there.
 */

export type ProjectStatus = 'planned' | 'active' | 'blocked' | 'done' | 'parked'

export const PROJECT_STATUSES: ProjectStatus[] = ['planned', 'active', 'blocked', 'done', 'parked']

export const STATUS_LABEL: Record<ProjectStatus, string> = {
  planned: 'Planned',
  active: 'Running',
  blocked: 'Blocked',
  done: 'Finished',
  parked: 'Parked'
}

export interface Phase {
  id: string
  name: string
  sort_order: number
  tasks: number
  done: number
}

export interface Project {
  id: string
  name: string
  client_id: string | null
  client_name: string | null
  brief: string | null
  status: ProjectStatus
  lead_id: string | null
  lead_name: string | null
  started_on: string | null
  due_on: string | null
  /** Partners only. Absent, not null, for everybody else. */
  fee_amount?: number | null
  fee_currency?: string
  deliverable_id: string | null
  archived_at: string | null
  phases: Phase[]
  /** Every task filed under it, and how many are done. Counted, not typed. */
  tasks: number
  done: number
}

/** How far along, as a percentage, or null when there is nothing to count yet. */
export function progressOf(p: { tasks: number; done: number }): number | null {
  if (p.tasks === 0) return null
  return Math.round((p.done / p.tasks) * 100)
}
